module.exports = __webpack_public_path__ + "static/schaffhauser-fernsehen-19fc01de214c81173a51d00f0d3dfd89.png";